// extracted by mini-css-extract-plugin
module.exports = {"giftInfo":"product-info-gift_giftInfo__Hd6X8"};